export default __webpack_public_path__ + "static/media/services.7030df3f.svg";